export default __webpack_public_path__ + "static/media/security.37dcae10.png";